import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Constants from '@/utils/Constants'
import ApiManager from '@/utils/ApiManager'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'VideoChatModifyModal',
  data () {
    return {
      processing: false,
    }
  },
  mounted () {
    this.init()
    console.log(this.values)
  },
  computed: {
    ...mapState({
      active: state => state.videoChatModifyModal.active,

      // model
      values: state => state.videoChatModifyModal.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),

    // result
    locationId () {
      return this.values.locationId
    },
    deviceSerial () {
      return this.values.deviceSerial
    },
    modelNumber () {
      return this.values.modelNumber
    },
    modelName () {
      return this.values.modelName
    },

    displayList() {
      return Constants.VideoChat.Display;
    },
    favoriteList() {
      return Constants.VideoChat.Favorite;
    },

    // input
    inpNickname: {
      get () {
        return this.values.inpNickname
      },
      set (value) {
        this.setInputValue({
          key: 'inpNickname',
          value: value
        })
      }
    },
    inpDisplay: {
      get () {
        return this.values.inpDisplay
      },
      set (value) {
        this.setInputValue({
          key: 'inpDisplay',
          value: value
        })
      }
    },
    inpFavorite: {
      get () {
        return this.values.inpFavorite
      },
      set (value) {
        this.setInputValue({
          key: 'inpFavorite',
          value: value
        })
      }
    },

    // disabled
    disableConfirmButton () {
      return !Validator.validText(this.inpNickname)
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'submit') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      hide: 'videoChatModifyModal/hide',
      setUpdated: 'videoChatModifyModal/setUpdated'
    }),
    ...mapMutations({
      setInputValue: 'videoChatModifyModal/setInputValue',
    }),

    init () {
      // データ更新フラグの初期化
      this.setUpdated(false)
    },

    confirmData () {
      this.showConfirm({
        key: 'submit',
        title: '',
        body: 'この内容で詳細情報を登録しますか？',
        acceptLabel: '登録'
      })
    },
    postData () {
      this.processing = true

      let parameters = {
        locationUuid: this.values.locationUuid,
        request: {
          nickName: this.inpNickname,
          display: this.inpDisplay,
          isFavorite: this.inpFavorite ? 1: 0,
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['videoChat'],
        ['v1VideoChatPatch'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '',
              body: '詳細情報を登録しました。'
            })

            // データ更新フラグを有効
            // 呼び出し元のページで一覧を更新するため
            this.setUpdated(true)

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}